<div class="notification-dropdown">
  <!-- Loading state -->
  <div class="loading-state" *ngIf="isLoading()">
    <div class="loading-content">
      <app-spinner [size]="32"></app-spinner>
    </div>
  </div>

  <!-- Notifications List -->
  <div class="notifications-list" *ngIf="!isLoading()">
    <!-- Empty state message -->
    <div class="empty-state" *ngIf="notifications().length === 0">
      <div class="empty-icon">
        <i class="fas fa-bell-slash"></i>
      </div>
      <h3 class="empty-title">No new notifications</h3>
      <p class="empty-description">You're all caught up! New notifications will appear here.</p>
    </div>

    <!-- Notification items -->
    <ng-container *ngFor="let notification of notifications()">
      <div class="notification-item" [class.marking-read]="markingAsRead === notification.id"
        (click)="onNotificationClick(notification, $event)" style="cursor: pointer;">
        <!-- Avatar -->
        <div
          [ngClass]="getAvatarClasses(notification.id, !!notification.user.avatar && !imageLoadError[notification.id])">
          <img *ngIf="notification.user.avatar && !imageLoadError[notification.id]" [src]="notification.user.avatar"
            [alt]="notification.user.name" (error)="onImageError(notification.id)"
            (load)="onImageLoad(notification.id)">
          <div *ngIf="!notification.user.avatar || imageLoadError[notification.id]" class="avatar-fallback">
            {{ getInitials(notification.user.name) }}
          </div>
        </div>

        <!-- Notification content -->
        <div class="notification-content">
          <!-- User name and main text -->
          <div class="notification-header">
            <span class="user-name">{{ notification.user.name }}</span>
            <div class="notification-title-wrapper">
              <span class="project-prefix" *ngIf="notification.titleData && notification.titleData.projectPrefix">{{
                toSentenceCase(notification.titleData.projectPrefix) }}</span>
              <span class="notification-text">{{ toSentenceCase((notification.titleData &&
                notification.titleData.baseTitle) || notification.title || '') }}</span>
            </div>
          </div>

          <!-- Project name (if available) -->
          <div class="project-name" *ngIf="notification.project">
            {{ notification.project }}
          </div>

          <!-- Comment snippet (if available) -->
          <div class="comment-snippet" *ngIf="notification.description">
            <p [innerHTML]="notification.description"></p>
          </div>

          <!-- Always render row so layout stays aligned; fallback when no parseable date -->
          <div class="notification-timestamp">
            <ng-container *ngIf="notificationTimeDisplay(notification) as tl; else tsFallback">
              <span class="date-label">{{ getDateLabel(tl) }}</span>
              <span class="time-value">{{ getTimeValue(tl) }}</span>
            </ng-container>
            <ng-template #tsFallback>
              <span class="time-value time-value--fallback">Recently</span>
            </ng-template>
          </div>
        </div>

        <!-- Mark as read button -->
        <div class="mark-read-btn" matTooltip="Mark as Seen"
          (click)="markAsSeen(notification); $event.stopPropagation()">
          <i class="fas fa-check"></i>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Footer with View All link -->
  <div class="dropdown-footer">
    <button type="button" class="btn-view-all" (click)="viewAllNotifications(); $event.stopPropagation()">
      View All
    </button>
    <button type="button" class="btn-cancel" (click)="markAllAsSeen(); $event.stopPropagation()"
      *ngIf="notifications().length >0">
      Mark All as Seen
    </button>

  </div>
</div>
